import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, Signal } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { toSignal } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Api } from '../../../../../../shared/constants/api';
import { FeatureFlagCollection } from '../../../../../../shared/interfaces/feature-flag.interface';
import { RoutingService } from '../../../../services/routing.service';
import { WorkspaceService } from '../../../../services/workspace.service';
import { $digitalProperty } from '../../../../../../shared/constants/digital-properties';
import { IWorkspaceClient } from '../../../../../../shared/interfaces/workspace.interface';
import { CustomValidators } from '../../../../services/helpers/form-custom-validators';
import { $workspace } from '../../../../../../shared/constants/workspace';
import { IDigitalProperty } from '../../../../../../shared/interfaces/digital-property.interface';
import { TenantService } from '../../../../services/tenant.service';
import { AppConfigService } from '../../../../services/app-config.service';
import { FeatureFlagService } from '../../../../services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-add-digital-property',
  templateUrl: './add-digital-property.component.html',
  styleUrls: ['./add-digital-property.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AddDigitalPropertyComponent implements OnInit {
  public title$: Observable<string>;
  public singleDigitalProperty: boolean | undefined;
  public FeatureFlagCollection: typeof FeatureFlagCollection = FeatureFlagCollection;
  public form: FormGroup;
  public availableWorkspaces$: Observable<IWorkspaceClient[]>;
  public $digitalProperty: typeof $digitalProperty;
  public $workspace: typeof $workspace;
  public readonly digitalAssetFormUpdateEnabled: Signal<boolean> = toSignal(
    this.featureFlagService.variation$(FeatureFlagCollection.digitalAssetFormUpdate, false).pipe(map(Boolean)),
    { initialValue: false },
  );

  @Input() public homeLink: string[] = ['/', Api.portfolio];
  @Input() public tenantId: string;
  @Input() public modalMode: boolean = false;
  @Output() public cancelled: EventEmitter<void> = new EventEmitter<void>();
  @Output() public save: EventEmitter<IDigitalProperty | undefined> = new EventEmitter<IDigitalProperty | undefined>();

  constructor(
    private routingService: RoutingService,
    private workspaceService: WorkspaceService,
    private formBuilder: FormBuilder,
    private tenantService: TenantService,
    private appConfigService: AppConfigService,
    private featureFlagService: FeatureFlagService,
  ) {
    this.title$ = this.routingService.pageTitle$.asObservable();
    this.$digitalProperty = $digitalProperty;
    this.$workspace = $workspace;
  }

  public onCancel(): void {
    if (this.modalMode) {
      this.cancelled.emit();
    }
  }

  public onSave(addedDigitalProperty?: IDigitalProperty): void {
    if (this.modalMode) {
      this.save.emit(addedDigitalProperty);
    }
  }

  public buildForm(): void {
    this.form = this.formBuilder.group({
      [$digitalProperty.workspaceId]: this.formBuilder.control(null, [CustomValidators.required]),
    });
  }

  public get selectedWorkspaceId(): string {
    return this.form.get($digitalProperty.workspaceId).value;
  }

  public ngOnInit(): void {
    this.buildForm();
    this.availableWorkspaces$ = this.appConfigService.isTenantEnabled()
      ? this.workspaceService.getActiveWorkspacesV2()
      : this.tenantService.getWorkspaces(this.tenantId);
  }
}
